"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useScrollTop = function () {
    var _a = (0, react_1.useState)(false), showScrollTop = _a[0], setShowScrollTop = _a[1];
    var checkScrollTop = function () {
        if (!showScrollTop && window.pageYOffset > window.innerHeight) {
            setShowScrollTop(true);
        }
        else if (showScrollTop && window.pageYOffset <= window.innerHeight) {
            setShowScrollTop(false);
        }
    };
    var scrollTop = (0, react_1.useCallback)(function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, []);
    (0, react_1.useEffect)(function () {
        window.addEventListener("scroll", checkScrollTop);
        return function () {
            window.removeEventListener("scroll", checkScrollTop);
        };
    });
    return {
        showScrollTop: showScrollTop,
        scrollTop: scrollTop,
    };
};
exports.default = useScrollTop;
